<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item class="style" prop="type" label="验证方式">
          <div>
            <el-radio-group v-model="ruleForm.verificationMethod" @change="changeType">
              <el-radio :label="0">汇款验证</el-radio>
              <el-radio :label="1">单位证明函验证</el-radio>
            </el-radio-group>
          </div>
          <span class="labels-tips"
            >审核通过后，需用开户名称与结算账户名称一致的银行账户，汇款指定金额（1元以下），汇款至指定银行账户</span
          >
        </el-form-item>
        <el-form-item v-if="verificationMethodType" class="style" label="单位证明函照片" prop="certificateLetterCopy">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.certificateLetterCopy && ruleForm.certificateLetterCopy.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                v-model="ruleForm.certificateLetterCopy"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return certificateLetterCopySuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <span class="labels-tips">单位证明函全部信息需打印，不支持手写商户信息，并加盖公章</span>
          </div>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      verificationMethodType: false,
      ruleForm: {
        verificationMethod: 0,
        certificateLetterCopy: [],
      },
      rules: {
        verificationMethod: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        certificateLetterCopy: [{ required: true, message: '请上传单位证明函照片', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    subjectData: {
      handler: function (data) {
        console.log(data);
        this.ruleForm = data.subjectDataVO;
        let certificateLetterCopyList = data.subjectDataVO.certificateLetterCopy.split(',');
        this.imgList = certificateLetterCopyList.map((item) => {
          const fileItem = {
            name: 'file',
            url: item,
            response: {
              data: item,
            },
          };
          return fileItem;
        });
      },
    },
  },

  methods: {
    certificateLetterCopySuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.certificateLetterCopy = file.response.data.url;
      console.log(this.ruleForm.certificateLetterCopy);
    },
    changeType(val) {
      if (val == 1) {
        this.verificationMethodType = true;
      } else {
        this.verificationMethodType = false;
      }
    },
    handleRemove() {
      this.ruleForm.certificateLetterCopy = [];
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
</style>
